import { ReactNode } from "react"
import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    card: {
        padding: "0 1rem",
        borderRadius: ".75rem",
        overflow: "hidden",
        background: theme.palette.background.paper,
    },
}))

type DrawerDetailsCardProps = Readonly<{
    children: ReactNode
}>

export function DrawerDetailsCard({ children }: DrawerDetailsCardProps) {
    const { classes } = useStyles()

    return <Box className={classes.card}>{children}</Box>
}
